import { ISpaceType } from 'spw-redux/modules/space_types/types';

export interface ICustomSpaceTypesState {
  busy: boolean;
  customSpaceTypes: ISpaceType[];
  currentState: string;
  currentParent: ISpaceType;
}

export enum CustomSpaceTypeStates {
  basicSpaceForm = 'basicSpaceForm',
  customInfoPage = 'customInfoPage',
}
